/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_ONETIME_DISPLAY_TYPE = 'Send Facebook One Time Consent'
const FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'

const isFacebookOneTimeConsentFormAction = R.propEq(
  'type',
  FACEBOOK_ONETIME_DISPLAY_TYPE
)

const convertFacebookConsentActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_DM_WIDGET_TYPE),
  message: {
    message: {
      attachment: {
        type: R.always('template'),
        payload: {
          title: R.prop('oneTimeConsentTitle'),
          payload: R.always('username:${senderName}'),
          template_type: R.always('one_time_notif_req')
        }
      }
    },
    recipient: {
      id: R.always('${senderId}')
    }
  }
})

export {
  isFacebookOneTimeConsentFormAction,
  convertFacebookConsentActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-onetime-consent.js